import React from 'react';
import PropTypes from 'prop-types';
import deLocale from 'date-fns/locale/pt-BR';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { TextField, FormGroup } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt';
import DateFnsUtils from '@date-io/date-fns';

export default function DateField({
  name, formik, value, onChange, format,
}) {
  const [locale, setLocale] = React.useState('pt');

  return (
    <FormGroup>
      <LocalizationProvider adapterLocale={deLocale} dateAdapter={DateFnsUtils}>
        <DatePicker

          label={(
            <div>
              {name}
            </div>
                                          )}
          InputLabelProps={{ shrink: true }}
          name={name}
          variant="inline"
          inputVariant="outlined"
          invalidDateMessage="Data Inválida"
          value={formik.values.date}
          onChange={onChange}
          onBlur={formik.handleBlur}
          format={format}
                                        // format="dd/MM/yyyy"
          fullWidth
          error={!!(formik.touched.date && formik.errors.date)}
          helperText={
                                            formik.touched.date
												&& formik.errors.date
												&& formik.errors.date
                                        }
                                        // inputFormat="DD/MM/YYYY"
          renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
    </FormGroup>
  );
}

DateField.defaultProps = {
  name: 'Data',
  formik: null,
  value: '12/12/2020',
  onChange: () => {},
};

DateField.propTypes = {
  /** Nome do campo de data - Usado para o placerhold */
  name: PropTypes.string,
  /** Objeto com valores iniciais, e validação dos valores de cada campo */
  formik: PropTypes.object,
  /** Valor do campo de data */
  value: PropTypes.string,
  /** Função chamada sempre que o campo tiver seu valor alterado */
  onChange: PropTypes.func,
};
